<template>
	<div class="container">
		<div class="step3">
			<div class="settlementWrap">
				<el-card shadow="never" class="bgF9F9F9">
					<div slot="header" class="clearfix">
						<span class="cardTitle">度假套餐</span>
					</div>
					<div class="orderInfo">
						<div class="orderTable">
							<template v-if="order.hotel_id">
								<span>酒店名称</span>
								<span>{{ order.hotel_name }}</span>
							</template>
							<template v-if="order.scenic_id">
								<span>景区名称</span>
								<span>{{ order.scenic_name }}</span>
							</template>
							<span>产品名称</span>
							<span>{{ order.goods_name }}</span>
							<template v-if="order.model == 'hotel'">
								<template v-if="order.goods_travel_type == 0">
									<span>入住日期</span>
									<span>{{ order.start_date }}</span>
									<span>离店日期</span>
									<span>{{ order.end_date }}</span>
								</template>
								<template v-else>
									<span>有效期</span>
									<span>{{ order.start_date }}~{{ order.end_date }}</span>
								</template>
							</template>
							<template v-if="order.model == 'ticket' || order.model == 'package'">
								<span>游玩日期</span>
								<span v-if="order.goods_travel_type == 1">{{ order.start_date }}~{{ order.end_date
									}}</span>
								<span v-else>{{ order.start_date }}</span>
							</template>
							<span>购买数量</span>
							<span>{{ order.quantity }}</span>
							<span>联系人</span>
							<span>{{ order.name }}</span>
							<span>手机号</span>
							<span>{{ order.phone }}</span>
							<template v-if="order.model != 'store'">
								<span>证件号</span>
								<span>{{ order.idcard }}</span>
							</template>
							<template v-else>
								<span>提货方式</span>
								<span>{{ order.express_type_name }}</span>
								<template v-if="order.express_type == 1">
									<span>提货地址</span>
									<span>{{ order.fetch_address }}</span>
								</template>
								<template v-else>
									<span>收货地址</span>
									<span>{{ order.address_province }}-{{ order.address_city }}-{{
								order.address_district }}-{{ order.address_detail }}</span>
								</template>
								<template v-if="order.express_name">
									<span>物流公司</span>
									<span>{{ order.express_name }}</span>
								</template>
								<template v-if="order.express_no">
									<span>物流单号</span>
									<span>{{ order.express_no }}</span>
								</template>
							</template>
						</div>
						<div class="total">订单总额<span class="price">￥{{ order.order_amount }}</span></div>
					</div>
				</el-card>
				<el-card shadow="never">
					<div slot="header" class="clearfix">
						<span class="cardTitle">付款信息</span>
					</div>
					<div class="payInfo">
						<div class="payTable">
							<span>流水号</span>
							<span>{{ order.order_no }}</span>
							<span>支付金额</span>
							<span>{{ formatPrice(order.pay_amount || 0) }}</span>
							<template v-if="order.coupon_name">
								<span>优惠金额</span>
								<span>{{ formatPrice(order.coupon_amount || 0) }} （{{ order.coupon_name }}）</span>
							</template>
							<template v-if="order.model == 'store'">
								<span>运费</span>
								<span>{{ formatPrice(order.express_amount || 0) }}</span>
							</template>
							<span>支付方式</span>
							<span>{{ order.payment_type_name }}</span>
							<span>支付时间</span>
							<span>{{ order.pay_time || '--' }}</span>
							<span>支付状态</span>
							<span>支付成功</span>
						</div>
					</div>
				</el-card>
			</div>
			<router-link :to="{ path: '/tourist/index' }" class="submitOrder">返回个人中心</router-link>
		</div>
	</div>
</template>

<script>
import { getOrderDetail } from '@/api/order';
export default {
	name: 'OrderSuccess',
	components: {

	},
	computed: {

	},
	data() {
		return {
			orderId: null,
			order: {},
			loading: false,
		}
	},
	created() {
		this.formatPrice = this.utils.formatPrice
		this.orderId = this.$route.params.id || '';
		this.getOrderDetail()
	},
	methods: {
		getOrderDetail() {
			this.loading = true;
			getOrderDetail({ id: this.orderId }).then(res => {
				this.loading = false;
				this.order = res.data;
				this.$store.dispatch("setModel", res.data.model);
			}).catch(() => {
				this.loading = false;
			});
		},
	},
}
</script>

<style lang="scss" scoped>
.container {
	width: 100%;
	display: flex;
	align-items: center;
	flex-direction: column;
	margin-bottom: 50px;

	.step3 {
		width: 75.7%;
		min-width: 1200px;
		display: flex;
		flex-direction: column;
		align-items: center;

		.settlementWrap {
			width: 100%;
			display: grid;
			grid-template-columns: 784fr 676fr;
			column-gap: 16px;

			.orderInfo {
				font-weight: 400;
				font-style: normal;
				font-size: 16px;
				color: #303133;
				padding: 20px 0;

				.orderTable {
					display: grid;
					grid-template-columns: 90px auto;
					column-gap: 10px;
					row-gap: 15px;

					:nth-child(odd) {
						text-align: right;
					}
				}

				.total {
					display: flex;
					align-items: center;
					justify-content: flex-end;
					margin-top: 15px;
				}
			}

			.payInfo {
				font-weight: 400;
				font-style: normal;
				font-size: 14px;
				color: #303133;
				padding: 20px 0;

				.payTable {
					display: grid;
					grid-template-columns: 90px auto;
					column-gap: 10px;
					row-gap: 15px;

					:nth-child(odd) {
						text-align: right;
					}
				}


			}
		}

		.submitOrder {
			font-weight: 500;
			font-style: normal;
			font-size: 26px;
			color: #FFFFFF;
			cursor: pointer;
			background-color: rgba(150, 33, 35, 1);
			text-align: center;
			padding: 25px 100px;
			box-sizing: border-box;
			width: fit-content;
			margin-top: 50px;
		}
	}

	.price {
		font-weight: 650;
		font-style: normal;
		color: #FF3D2E;
		font-size: 24px;
	}

	.cardTitle {
		font-weight: 650;
		font-style: normal;
		font-size: 22px;
		color: #000000;
	}

}
</style>
